import { useMemo } from "react";
import { Link } from "react-router";

import { Typography, useMediaQuery } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid";
import TilleyDataGrid from "components/shared/DataGrid/TilleyDataGrid";
import { CustomWidthTooltip } from "mui-toolkit/CustomWidthTooltip";
import DeleteConfirmationButton from "mui-toolkit/DeleteConfirmationButton";
import { formatPrice } from "utility/formatters";

import { EditIcon } from "../Icons/Icons";

export default function EquipmentInventoryDataTable({
  equipmentItems,
  onChange,
  handleEditClick,
  isLoading,
  pageSizes = [5, 10, 25, 50, 100],
  rowHeight = 80,
}) {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("lg"), { noSsr: true });

  const columns = useMemo(
    () => [
      {
        field: "name",
        headerName: "Name",
        flex: 1.5,
        renderCell: (params) => (
          <Typography color="primary" component={Link} to={`/financial/equipment/${params.row.id}`}>
            {params.value}
          </Typography>
        ),
      },
      {
        field: "condition",
        headerName: "Condition",
        flex: 1.5,
      },
      {
        field: "category",
        headerName: "Category",
        flex: 1.5,
      },
      {
        field: "value",
        headerName: "Price",
        flex: 1,
        renderCell: (params) => {
          return formatPrice(params.row.value, 0);
        },
      },
      {
        field: "year",
        headerName: "Year",
        flex: 1,
      },
      {
        field: "actions",
        headerName: "Actions",
        type: "actions",
        headerAlign: "right",
        align: "right",
        width: 150,
        sortable: false,
        getActions: (params) => {
          return [
            <CustomWidthTooltip key="delete" title="Delete" placement="top" arrow>
              <DeleteConfirmationButton item={params.row} onChange={onChange} />
            </CustomWidthTooltip>,
            <GridActionsCellItem
              key="view"
              icon={<EditIcon />}
              label="View Details"
              data-testid={`open-equipment-${params.row.name}`}
              onClick={() => handleEditClick(params.row)}
            />,
          ];
        },
        flex: 0,
      },
    ],
    [onChange, handleEditClick]
  );

  return (
    <TilleyDataGrid
      rows={equipmentItems || []}
      columns={columns}
      pageSizeOptions={pageSizes}
      defaultPageSize={isMobile ? 5 : 10}
      gridKey="equipment-inventory"
      getRowId={(row) => row.id}
      rowHeight={rowHeight}
      isLoading={isLoading}
      sx={{ width: "99%", boxSizing: "border-box" }}
    />
  );
}
